export default __webpack_public_path__ + "static/media/help-icon.c9317794.svg";